export var ShopThumbType = /*#__PURE__*/ function(ShopThumbType) {
    ShopThumbType["PCP"] = "pcp";
    ShopThumbType["COMMISSION"] = "commission";
    return ShopThumbType;
}({});

//# sourceMappingURL=types.js.map